import React from 'react';
import { string, number } from 'prop-types';

import './range-slider.m.css';

const RangeSelector = ({
  min = 0,
  max = 100,
  currentValue = 50,
  label = 'Range',
  labelOne = 'Low',
  labelTwo = 'High'
}) => {
  const MIN = min;
  const MAX = max;
  const newVal = Number(((currentValue - MIN) * 100) / (MAX - MIN));
  return (
    <div styleName="range-slider">
      <div styleName="header">{label}</div>
      <div styleName="label">
        <span>{labelOne}</span>
        <span>{labelTwo}</span>
      </div>
      <div styleName="slidecontainer">
        <input
          type="range"
          min={MIN}
          max={MAX}
          value={currentValue}
          styleName={`slider positive`}
          style={{
            backgroundSize: ((currentValue - MIN) * 100) / (MAX - MIN) + '% 100%'
          }}
        />
        <span
          styleName="label-value"
          style={{
            left: `calc(${newVal}% - 40px)`
          }}
        >
          {currentValue}
        </span>
      </div>
      <div styleName="label">
        <span styleName="label-value">{MIN}</span>
        <span styleName="label-value">{MAX}</span>
      </div>
    </div>
  );
};

RangeSelector.propTypes = {
  min: number,
  max: number,
  currentValue: number,
  label: string,
  labelOne: string,
  labelTwo: string
};

export default RangeSelector;
